import './BookPdf.scss';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HeaderTitle from '../comm/HeaderTitle';
import redux from '../reduxToolkit/redux';
import { useSelector, useDispatch } from 'react-redux';
import { setList_pdf, setRow_pdf, setHeaderInfo } from '../reduxToolkit/redux';
import { Button } from '@mui/material';

const BookPdf = ({ setIsModal }) => {
    const dispatch = useDispatch();

    const imgUrl = process.env.REACT_APP_imgUrl;
    const headerInfo = useSelector(state => state.reduxStore.headerInfo);
    const list_pdf = useSelector(state => state.reduxStore.list_pdf);
    const rowIdx_pdf = useSelector(state => state.reduxStore.rowIdx_pdf);

    const [imagePath, setImagePath] = useState('');
    const [title, setTitle] = useState('');
    const [selectedListItem, setSelectedListItem] = useState({});
    const [error, setError] = useState(null);


    useEffect(() => {
        setSelectedListItem(list_pdf[rowIdx_pdf]);
        // console.log(list_pdf, '=========list_pdf');
        // console.log(rowIdx_pdf,' rowIdx_pdf');
    }, []);

    // useEffect(() => {
    //     if (selectedListItem) { //(acaCode=1000인듯)
    //         const newImagePath = selectedListItem.imagePath;
    //         console.log(newImagePath, '=======newImagePathnewImagePath');
    //         setImagePath(newImagePath);  
    //     }
    // }, [selectedListItem, headerInfo]); // 의존성 배열에 selectedListItem과 headerInfo 추가

    useEffect(() => {
        const selectedListItem = list_pdf[rowIdx_pdf];
        // console.log(selectedListItem, 'selectedListItem');
        if (!selectedListItem) {
            setError('Selected list item not found.');
            return;
        }

        const fetchData = async () => {
            if(!selectedListItem.imagePath) return;//이미지 없으면 나가
            try {
                const newImagePath = await fncS4.getS3Path(selectedListItem.imagePath);
                setImagePath(newImagePath);
                console.log(newImagePath, 'newImagePath');
            } catch (error) {
                console.error("Error fetching image path:", error);
                setError("Failed to load image.");
            }
        };

        fetchData();
    }, [selectedListItem, headerInfo]);

    //========================================================================
    return (
        <div className='BookPdf'>     
            <HeaderTitle title={title} direction={1} onBackClick={() => setIsModal(false)} />
           
            <Button className='btnClose-me' onClick={() => setIsModal(false)} >
                <i class="fa-solid fa-xmark"></i>
            </Button> 

            <div className='box-imgPdf'>
                {imagePath && <img className='imgPdf' src={imagePath} alt={`Page ${selectedListItem.page} of ${selectedListItem.pdfFileName}`} />}
            </div>
           
        </div>
    );
}

export default BookPdf;